import { Calculator } from "./lib/Calculator";
import { Validate, ValidationRule } from "./lib/Validate";
var createApp = Vue.createApp, ref = Vue.ref, reactive = Vue.reactive, computed = Vue.computed;
createApp({
    setup: function (props) {
        // console.log("cost settings", costSettings);
        // console.log("material types", materialTypes);
        var total = reactive({
            upper: "-",
            average: "-",
        });
        var userInput = reactive({
            total_depth: 100,
            average_production: 100,
            annular_seal_depth: 50,
        });
        var submittedOnce = ref(false);
        var userInputErrors = computed(function () {
            var _a, _b, _c, _d, _e;
            var errors = {};
            if (submittedOnce.value) {
                var validate = new Validate({
                    annular_seal_depth: (_a = {}, _a[ValidationRule.Number] = true, _a),
                    casing_screen_material_type: (_b = {}, _b[ValidationRule.Required] = true, _b),
                    water_quality: (_c = {}, _c[ValidationRule.Required] = true, _c),
                    reliable_estimate: (_d = {}, _d[ValidationRule.Required] = true, _d),
                    sound_control: (_e = {}, _e[ValidationRule.Required] = true, _e),
                });
                errors = validate.check(userInput);
            }
            return errors;
        });
        var userInputHasErrors = computed(function () {
            return Object.values(userInputErrors.value).some(function (error) { return error !== ""; });
        });
        var calculateCost = function () {
            submittedOnce.value = true;
            if (userInputHasErrors.value) {
                return;
            }
            if (Number(userInput.annular_seal_depth) < 50) {
                userInput.annular_seal_depth = 50;
            }
            var calculator = new Calculator({ userInput: userInput, costSettings: costSettings });
            calculator.calculate();
            var currenyFormatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            });
            total.upper = currenyFormatter.format(calculator.total.upper);
            total.average = currenyFormatter.format(calculator.total.average);
            // console.table(calculator.costs);
        };
        return {
            total: total,
            materialTypes: materialTypes,
            userInput: userInput,
            onSubmit: calculateCost,
            userInputErrors: userInputErrors,
            userInputHasErrors: userInputHasErrors,
            rangeOutputStyles: computed(function () {
                var depthPosition = ((userInput.total_depth - 100) * 100) / 1600;
                var productionPosition = ((userInput.average_production - 100) * 100) / 5000;
                return {
                    total_depth: {
                        maxWidth: "75px",
                        left: "calc(" + depthPosition + "% - 10px)",
                    },
                    average_production: {
                        maxWidth: "75px",
                        left: "calc(" + productionPosition + "% - 10px)",
                    },
                };
            }),
        };
    },
}).mount("#wcc-form");
